import { render, staticRenderFns } from "./ackusativ-och-dativobjekt.vue?vue&type=template&id=3d5075e0&scoped=true"
import script from "./ackusativ-och-dativobjekt.vue?vue&type=script&lang=js"
export * from "./ackusativ-och-dativobjekt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5075e0",
  null
  
)

export default component.exports